export const HeartAnalytics = ({ size = 24 }: { size?: number }) => {
  const iconSize = Number(size);

  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(0 1)" vectorEffect="non-scaling-stroke">
        <path
          d="M7.99981 13.2377C7.87287 13.2377 7.74541 13.2128 7.61741 13.163C7.48941 13.1137 7.38007 13.0396 7.28941 12.9406L2.2366 8.00944C1.76994 7.55574 1.41367 7.04474 1.1678 6.47644C0.922471 5.90814 0.799805 5.32637 0.799805 4.73111C0.799805 3.61474 1.15927 2.66688 1.8782 1.88755C2.59714 1.10822 3.4798 0.718292 4.52621 0.717773C5.07341 0.717773 5.59981 0.828477 6.10541 1.04988C6.61047 1.27129 7.06247 1.5824 7.46141 1.98322L7.92804 2.46318C7.96733 2.5036 8.03225 2.50357 8.0715 2.46312L8.50781 2.01355C8.91367 1.59251 9.37181 1.27129 9.88221 1.04988C10.3926 0.828477 10.9163 0.717773 11.4534 0.717773C12.4998 0.717773 13.3859 1.1077 14.1118 1.88755C14.8377 2.6674 15.2003 3.60851 15.1998 4.71088C15.1998 5.31651 15.0763 5.90348 14.8294 6.47177C14.5819 7.04007 14.2265 7.55107 13.763 8.00477L8.69101 12.9413C8.58914 13.0398 8.48034 13.1137 8.36461 13.163C8.24887 13.2123 8.12727 13.2369 7.99981 13.2369"
          stroke="white"
          strokeWidth="1.5"
        />
        <path
          d="M1.2002 6.52073H5.04431C5.07729 6.52073 5.10814 6.53698 5.12679 6.56417L6.58019 8.68373C6.61646 8.73713 6.66126 8.77887 6.71459 8.80895C6.76793 8.83902 6.83033 8.85406 6.90179 8.85406C6.99299 8.85406 7.07353 8.82969 7.14339 8.78095C7.21326 8.73221 7.26446 8.6648 7.29699 8.57873L8.57396 4.855C8.60064 4.77718 8.70464 4.76307 8.75109 4.83098L9.78019 6.33562C9.81913 6.38954 9.86793 6.43387 9.92659 6.46861C9.98526 6.50336 10.0503 6.52073 10.1218 6.52073H14.8002"
          stroke="white"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
};
